import { setParamsByUser } from 'utils/analytics/setParamsByUser';
import { getSessionType, userBasicGuard } from 'utils/clickme';
import { Permissions } from 'utils/constants/permissions';
import { getExperiments, setExperimentCookieByArgument } from 'utils/experiments';
import { getXRequestId } from 'utils/getXRequestId';

import { Requirements } from 'app/routes';

import { setXRequestId } from 'store/autoReducers';
import { Action } from 'store/createReducer';
import { Balance, setBalance } from 'store/models/balance';
import { ClickmeConfig, setClickmeConfig } from 'store/models/clickme';
import { ExperimentsEnabledResponseDTO, setEnabledExp } from 'store/models/experiments';
import { setStoppedCampaigns, StoppedCampaignsDto } from 'store/models/stoppedCampaigns';
import { setLoadUser, setSessionType, setUser, setUserPermissions, UserInfoDto, UserType } from 'store/models/user';

const UserRequirements: Requirements<{
    user: UserInfoDto;
    balance: Balance;
    config: ClickmeConfig;
    experiments: ExperimentsEnabledResponseDTO;
    stoppedCampaigns: StoppedCampaignsDto;
}> = {
    methods: () => ({
        user: { url: '/api/v1/user' },
        balance: { url: '/api/v1/account/balance', cacheable: false },
        config: { url: '/api/v1/config' },
        experiments: { url: '/api/v1/employer/experiments/available', cacheable: false },
        stoppedCampaigns: { url: '/api/v1/campaigns/stopped', cacheable: false },
    }),
    resolve: ({ result: { user, balance, config, experiments, stoppedCampaigns }, state }) => {
        const { actualUser } = user;
        const permissions = [Permissions.ViewPersonalAreaSection];
        if (actualUser && actualUser.userType === UserType.SuperAdmin) {
            permissions.push(Permissions.ViewAccountCreateContractFields);
        }
        setExperimentCookieByArgument();
        const actions = [
            setUserPermissions(permissions),
            setLoadUser(false),
            setUser(user.user),
            setSessionType(getSessionType(actualUser)),
            setBalance(balance),
            setClickmeConfig(config),
            setEnabledExp(getExperiments(experiments.control, experiments.experiment)),
            setStoppedCampaigns(stoppedCampaigns),
        ];
        setParamsByUser(user.user, state.user.loginData);
        return actions;
    },
    error: (err) => {
        // не очень логично, что ошибки, которые происходят в pages/requirements падают сюда, а не в свой обработчик ошибок
        // todo: разобраться, можно ли что-то с этим сделать - https://jira.hh.ru/browse/HH-244644
        const actions: Action[] = [setUserPermissions(userBasicGuard(err)), setLoadUser(false)];
        const XRequestId = getXRequestId(err);
        if (XRequestId) {
            actions.push(setXRequestId(XRequestId));
        }
        return actions;
    },
};

export default UserRequirements;
